// extracted by mini-css-extract-plugin
export default {"container":"JXGS","content":"Wvno","main":"OvSP","stage":"ApEY","split-frame":"_Hae","splitFrame":"_Hae"};